import { useEffect, useState } from "react";
import "./App.css";
import Login from "./screens/Login/Login";
import MainFrame from "./screens/MainFrame/MainFrame";
import secureLocalStorage from "react-secure-storage";
import { stdObject } from "./data/types/stdObject";
import { useDispatch } from "react-redux";
import { sendData } from "./services/sendData";
import { mainConfig } from "./data/main";
import { deviceDetect } from "react-device-detect";
import { getConfig } from "./services/getConfig";
import {
  clearSessionOnExit,
  handleBeforeUnload,
  handleUnload,
  handleVisibilityChange,
} from "./screens/Login/functions/handlePage";
import { directReload } from "./screens/MainFrame/functions/directReload";
import { getCurrentDate } from "./utils/getCurrentDate";
import { recordInitData } from "./screens/Login/functions/recordInitData";

function App() {
  const [hasSession, setHasSession] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [msgType, setMsgType] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    // console.log("data", deviceDetect(window.navigator.userAgent));
  }, []);

  const logoutAction = (msg: any = "") => {
    // console.log("logoutAction", typeof msg, msg);
    if (typeof msg === "string" && msg !== "") {
      setMsgType(msg);
    }
    // Fire-and-forget: flips presence to offline immediately rather than
    // waiting for the chat heartbeat's last-active timestamp to go stale.
    // Must fire before the token is cleared, since sendData reads it from
    // storage at call time.
    sendData({ endPoint: "setChatOffline" });
    secureLocalStorage.removeItem("token");
    secureLocalStorage.removeItem("branch");
    secureLocalStorage.removeItem("branchSelectedAtLogin");
    setHasSession(false);
  };

  useEffect(() => {
    login();

    // Eventos para desktop
    window.addEventListener("beforeunload", handleBeforeUnload);
    window.addEventListener("beforeunload", clearSessionOnExit);
    window.addEventListener("unload", handleUnload);
    window.addEventListener("unload", clearSessionOnExit);

    // Eventos extra para móviles
    window.addEventListener("pagehide", handleUnload);
    window.addEventListener("pagehide", clearSessionOnExit);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => directReload(false);
  }, []);

  const login = async (callback?: () => void) => {
    const config = await getConfig();
    mainConfig.url = config.url;

    try {
      const token = secureLocalStorage.getItem("token");
      if (typeof token === "string" && token.length > 10) {
        setIsLoading(true);
        const responseInfoService: stdObject = await sendData({
          endPoint: "userAllInfo",
          payload: { date: getCurrentDate() },
          url: mainConfig.url,
        });
        // console.log("responseInfoService", responseInfoService);
        if (responseInfoService.success && responseInfoService.status) {
          if (
            await recordInitData({ initData: responseInfoService, dispatch })
          ) {
            setMsgType("");
            setHasSession(true);
          } else {
            console.log("App recordInitData error");
          }
        } else {
          // console.log(
          //   Object.keys(responseInfoService)
          //     .map((e) => responseInfoService[e])
          //     .join(""),
          // );
        }
        setIsLoading(false);
      }
    } catch (error) {
      // console.log("login error: ", error);
    }

    if (callback) callback();
  };

  const loginPack = { setMsgType, setHasSession, setIsLoading };

  return hasSession ? (
    <MainFrame logoutAction={logoutAction} />
  ) : (
    <Login
      isLoading={isLoading}
      msgType={msgType}
      loginPack={loginPack}
      logoutAction={logoutAction}
    />
  );
}

export default App;
